import _ from 'lodash';
import React from 'react';

import { browserHistory } from 'react-router';
import ModalPopover from '../ModalPopover';
import commonUtil from '../../../utils/commonUtil';
import { closeModalIconBlack } from '../../NewHeader/Header/svgIcons';

export default class ConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    this.pathName = '';
    this.message = this.props.message || '';
  }

  open = (path) => {
    this.pathName = path;
    this.modal.handleShow();
    this.actionPromise = new Promise((resolve) => {
      this.resolveActionPromise = resolve;
    });
    return this.actionPromise;
  };

  handleAcceptButtonClick = (e) => {
    const { cancelClick = () => {}, removeRouteLeaveHook = () => {} } = this.props || {};

    if (!_.isNil(this.resolveActionPromise) && _.isFunction(this.resolveActionPromise)) {
      this.resolveActionPromise(true);
    }

    if (window.location.pathname !== '/crearunacuenta') {
      cancelClick(e);
      removeRouteLeaveHook();

      this.modal.handleHide();
      browserHistory.push('/');
      return;
    }

    browserHistory.push('/');
  };

  handleCancelButtonClick = () => {
    if (!_.isNil(this.resolveActionPromise) && _.isFunction(this.resolveActionPromise)) {
      this.resolveActionPromise(false);
    }

    if (window.location.pathname !== '/crearunacuenta') {
       this.modal.handleHide();
      return this.cancelModalOption;
    }
    return browserHistory.push('/');
  };
     
  render() {
    const contentStyle = {
      width: '100%',
      maxWidth: '500px',
      padding: '0px',
      margin: '0 auto',
      borderRadius: '8px',
      backgroundColor: '#fff',
    };
    return (
      <ModalPopover modalId={this.props.id || ''} contentStyle={contentStyle} isModal="true" modalClass="centerModal cmodal_new" ref={modal => (this.modal = modal)}>
        {/* <i id="closeModal" className="icon-cerrar close 1" data-dismiss="modal" aria-label="Close" /> */}
        <div className='modalHeader_new row'>
               <p className='modal_title_new'>¿Salir del formulario?</p>
               <span onClick={this.handleCancelButtonClick} className='close_icon_new' id="closeModal">
                  {closeModalIconBlack}
                </span>
        </div>
        <div className='modalBody_new_content row'>
          <p className='modalTxt_new'>Si sales del formulario para la creación de tu evento no se guardara la información que has ingresado.</p>
          <p className='modalTxt_new'>¿Estas seguro de que deseas salir? </p>
        </div>
        <div className="row modalFooter_wap">
          <div className="col-xs-6 btnSalirContainer">
            <button
              id="closeModal"
              className="btnSecondaryAction size-Full closeModal btnSalir"
              data-dismiss="modal"
               onClick={this.handleAcceptButtonClick}>
            
              Salir del formulario
            </button>
          </div>
          <div className="col-xs-6 btnVolverContainer">
            <button className="btnPrimaryAction size-Full btnVolver" data-dismiss="modal"
            onClick={this.handleCancelButtonClick}
            >
              Volver al formulario
            </button>
          </div>
        </div>
      </ModalPopover>
    );
  }
}
